const sectionsToRender = [
  {
    id: '#cart-counter',
    section: 'cart-counter',
    selector: '#shopify-section-cart-counter'
  },
  {
    id: '#CartDrawer-Body',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Body'
  }
];

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      event => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.querySelector('#CartDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.setCartLink();
    this.parentElement.addEventListener(
      'shopify:section:select',
      () => this.open()
    );
    this.parentElement.addEventListener(
      'shopify:section:deselect',
      () => this.close()
    );
  }

  setCartLink() {
    const cartLink = document.querySelector('[data-cart-link]');
    cartLink?.setAttribute('role', 'button');
    cartLink?.setAttribute('aria-haspopup', 'dialog');
    cartLink?.addEventListener('click', event => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink?.addEventListener('keydown', event => {
      if (event.code.toUpperCase() !== 'SPACE') return;
      event.preventDefault();
      this.open(cartLink);
    });
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.classList.add('is-visible');
    this.addEventListener(
      'transitionend',
      () => {
        this.focusOnCartDrawer();
      },
      { once: true }
    );
    bodyScroll.lock(this.querySelector('[role="dialog"]'));

    if (document.querySelector('product-bar')) {
      document.querySelector('product-bar').style.opacity = '0';
    }
  }

  close() {
    this.classList.remove('is-visible');
    removeTrapFocus(this.activeElement);

    const isHeaderMenuOpen = header.classList.contains('menu-open');

    if (isHeaderMenuOpen) {
      return;
    }

    bodyScroll.unlock(this.querySelector('[role="dialog"]'));

    // if we are on the cart page, resubmit form
    if (window.location.pathname === '/cart') {
      const cartDrawerForm = document.getElementById('CartDrawer-FormSummary');
      if (cartDrawerForm) {
        cartDrawerForm.submit();
      }
    }

    if (document.querySelector('product-bar')) {
      document.querySelector('product-bar').removeAttribute('style');
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  focusOnCartDrawer() {
    const containerToTrapFocusOn = this.firstElementChild;
    const focusElement = this.querySelector('[data-drawer-close]');
    trapFocus(containerToTrapFocusOn, focusElement);
  }

  renderContents(response, open = true) {
    this.getSectionsToRender()?.forEach(section => {
      const sectionElement = document.querySelector(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector
      );
    });
    if (!open) {
      return;
    }

    this.open();
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
class CartUpdater {
  constructor(cartContainerSelector) {
    this.cartContainerSelector = cartContainerSelector;
  }

  async fetchCartData() {
    try {
      const response = await fetch(window.location.pathname, {
        headers: { "Content-Type": "text/html" },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch cart data");
      }

      return await response.text();
    } catch (error) {
      console.error("Error fetching cart data:", error);
      return null;
    }
  }

  async updateCartHTML() {
    const cartContainer = document.querySelector(this.cartContainerSelector);
    if (!cartContainer) {
      console.error(`Cart container not found for selector: ${this.cartContainerSelector}`);
      return;
    }

    const cartHTML = await this.fetchCartData();
    if (cartHTML) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(cartHTML, "text/html");
      // const cartCount = doc.querySelector('.header__cart__status');
      const newCartContent = doc.querySelector(this.cartContainerSelector);
      // const itemCount =  parseInt(doc.querySelector(this.cartContainerSelector).getAttribute('data-count'))
      //  document.querySelectorAll('.header__cart__status')?.forEach(count => {
      //    count.innerHTML = cartCount.innerHTML
      //  })
      document.querySelector('[cart-drawer-wraper]')?.classList.remove('is-loading-drawer')
      if (newCartContent) {
        cartContainer.innerHTML = newCartContent.innerHTML;      
      } else {
        console.error("Failed to find the new cart content in the fetched HTML.");
      }
    }
  }
}

window.CartUpdater = CartUpdater;

document.addEventListener('click', function (event) {
  if (event.target.matches('.add_upsell_to_cart')) {
    const dataId = event.target.getAttribute('data-id');
    document.querySelector('[cart-drawer-wraper]')?.classList.add('is-loading-drawer')
    addToCart(dataId, () => {
      refreshCart();
    });
  }
});
function addToCart(dataId, callback) {
  if (!dataId) {
    console.error('Invalid data-id');
    return;
  }

  const data = {
        id: parseInt(dataId),
        quantity: 1
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json', // Equivalent to contentType
    },
    body: JSON.stringify(data) // Equivalent to data: JSON.stringify(data)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      console.log('Item added to cart:', data);
      if (callback) callback();
    })
    .catch(error => console.error('Error adding item to cart:', error));
}

function refreshCart() {
  const cartUpdater = new CartUpdater("cart-drawer");
  cartUpdater.updateCartHTML();
}